import { PropType, defineComponent, computed } from 'vue'
import { Store } from 'pinia'
import {
  ComponentActions,
  ComponentState,
} from '../../nsh5/localStores/component'
import HandleBox from './handleBox'
import SearchPanel from '../searchPanel'

export default defineComponent({
  name: 'handle-box',
  emits: ['handleFilter', 'hideFilter', 'goBackHome'],
  components: {},
  props: {
    componentStore: {
      // 用于同一项目功能模块间的通信
      type: Object as PropType<Store<string, ComponentState, {}, ComponentActions>>,
      default: null,
    },
    xinfaView: {
      // 信发设备使用此组件,需要隐藏handleBox组件
      type: Boolean,
      default: false,
    },
  },
  setup: (props) => {
    // 获取组件配置
    const componentsConfig: any = window.NSComponentsConfig
    const componentStore = computed(() => props.componentStore)

    return () => (
      <>
        {componentsConfig?.common?.show && !componentStore.value.showSearchPanel ? (
          <HandleBox componentStore={componentStore.value}></HandleBox>
        ) : (
          <SearchPanel componentStore={componentStore.value}></SearchPanel>
        )}
      </>
    )
  },
})
